import React from 'react';
import { FormattedMessage } from 'react-intl';
import {FetchKeyStateContext} from '../../components/FetchKey';
import {graphql, useLazyLoadQuery} from 'react-relay/hooks';
import {ErrorBoundary} from 'react-error-boundary';
import EventCard from '../../components/event-card/event-card';
import './trends.scss';

const Trends = () => {
    const containerRef = React.useRef();
    const blurRef = React.useRef();
    const fetchKeyState = React.useContext(FetchKeyStateContext);
    const {viewer: {trendingServices}} = useLazyLoadQuery(
        graphql`
            query trendsHomePagesTrendingServicesQuery {
                viewer {
                    trendingServices {
                        service {
                            id
                            slug
                            name
                            nameUk
                            details
                            detailsUk
                            location
                            locationUk
                            start
                            end
                            strategy
                            every
                            warp
                            target
                            description
                            pin
                        }
                    }
                }
            }
        `,
        {},
        {fetchKey: fetchKeyState}
    );
    const scrollHandler = () => {
        if (containerRef.current && blurRef.current) {
            if (containerRef.current.scrollLeft !== 0) {
                if (!blurRef.current.classList.contains('events-container-blur--start')) {
                    blurRef.current.classList.add('events-container-blur--start');
                }
            } else {
                blurRef.current.classList.remove('events-container-blur--start');
            }
            if (containerRef.current.scrollLeft < (containerRef.current.scrollWidth - containerRef.current.offsetWidth)) {
                if (!blurRef.current.classList.contains('events-container-blur--end')) {
                    blurRef.current.classList.add('events-container-blur--end');
                }
            } else  {
                if (blurRef.current.classList.contains('events-container-blur--initial')) {
                    blurRef.current.classList.remove('events-container-blur--initial');
                }
                blurRef.current.classList.remove('events-container-blur--end');
            }
        }
    };
    return (
        <div className='trends'>
            <div className='display-sm mw768-display-lg semibold color-gray-900'><FormattedMessage defaultMessage='Hot events'/></div>
            <div className='trends-block position-relative'>
                <div  ref={blurRef} className='events-container-blur events-container-blur--initial events-container-blur--end'></div>
                <div ref={containerRef} onScroll={scrollHandler} className='events-container display-grid column-gap-1dot5rem mw768-column-gap-2rem'>
                    {trendingServices.map((entry) =>
                        <div
                            key={entry.service.id}
                            data-insights-object-id={entry.service.id}
                            data-service-slug={entry.service.slug}
                            className='events-item'
                        >
                            <ErrorBoundary>
                                <EventCard {...{service: entry.service, mode: 'trends', highlightCover: true}} />
                            </ErrorBoundary>
                        </div>   
                    )}
                </div>
            </div>
        </div>
    )
};

export default React.memo(Trends);